import dayjs from "dayjs";

import { Strings } from "@app/constants";

export const RenderTimeStamp = (date: string) => {
  if (date) {
    const timeStamp = dayjs(date).format("DD-MMM-YYYY");
    return timeStamp;
  } else return Strings.common.na;
};
